import { render, staticRenderFns } from "./NodeBackground.vue?vue&type=template&id=4a7519ae&scoped=true&"
import script from "./NodeBackground.vue?vue&type=script&lang=js&"
export * from "./NodeBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7519ae",
  null
  
)

export default component.exports